import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import Popup from 'components/Popup';
import { useConfig } from 'config/ConfigContext';

const unSupportedStates = {
  CT: 'Connecticut',
  DC: 'District of Columbia',
  IA: 'Iowa',
  MA: 'Massachusetts',
  ME: 'Maine',
  NE: 'Nebraska',
  NH: 'New Hampshire',
  VT: 'Vermont',
  WI: 'Wisconsin',
  WV: 'West Virginia',
};

const SmartyStreetsPopup = ({ type, handleAbort, data }) => {
  const { smartyStreetEnforce } = useConfig();

  const getTitle = () => {
    const titles = {
      1: "You didn't enter enough information",
      2: `We Couldn't Validate Your Address`,
      3: 'P.O Box address is not allowed',
      4: `Currently we do not accept loan applications for residents of the state of ${unSupportedStates[data?.state]}`,
    };
    return titles[type];
  };

  const getContent = () => {
    if (type !== 4 && data) {
      return `${data.address || ''} ${data.city || ''} ${get(data, 'state.label') || ''} ${data.zipcode || ''}`;
    }
    return null;
  };

  const getActions = () => {
    const actions = [];
    
    if (type !== 1 && !smartyStreetEnforce) {
      actions.push({
        label: 'Use this address',
        onClick: handleAbort,
      });
    }
    
    actions.push({
      label: 'Edit Address',
      onClick: handleAbort,
      modifier: 'outline'
    });
    
    return actions;
  };

  const getTitleColor = () => {
    return type === 1 ? 'text-[#CEA737]' : 'text-slate-800';
  };

  return (
    <Popup
      title={<span className={getTitleColor()}>{getTitle()}</span>}
      content={getContent()}
      actions={getActions()}
    />
  );
};

SmartyStreetsPopup.propTypes = {
  handleAbort: PropTypes.func.isRequired,
  type: PropTypes.number,
  data: PropTypes.object,
};

export default SmartyStreetsPopup;